import { Text } from '@mote/ui'
import React from 'react'
import styled from 'styled-components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'
import { useTranscriptDoppelganger } from './useTranscriptDoppelganger'

const NUM_OF_LINES = 2
const LINE_HEIGHT = '1.3'

export const MoteCardRichTranscriptionInline = ({ transcript }) => {
  const {
    paused: isPaused,
    playing,
    theme,
    position,
    duration,
    playerDimensions
  } = useMotePlayer()
  const [parameters, setParameters] = React.useState(null)
  const rootRef = React.useRef(null)

  const textFontSize = React.useMemo(() => {
    return moteCardFluidDimensionsAdjuster(28, 14, playerDimensions?.width)
  }, [playerDimensions])

  const height = React.useMemo(() => {
    return textFontSize * LINE_HEIGHT * NUM_OF_LINES
  }, [textFontSize])

  const { checkFit } = useTranscriptDoppelganger(
    rootRef,
    textFontSize,
    playerDimensions?.width,
    height
  )

  const transcriptFrame = React.useMemo(() => {
    if (!parameters) return []

    const frame =
      position / parameters.pace <= 1
        ? 0
        : Math.floor(position / parameters.pace)

    return parameters.frames[frame]
  }, [position, parameters])

  React.useEffect(() => {
    if (!rootRef.current) return

    calculateParameters()
  }, [rootRef, playerDimensions, transcript])

  function calculateParameters() {
    const maxCharacters = calculateMaxCharacters()

    const tempArr = []
    const words = transcript.split(' ')

    let str = ''
    for (let i = 0; i < words.length; i++) {
      const word = words[i]
      if (`${str} ${word}`.length <= maxCharacters) {
        str += `${str.length === 0 ? '' : ' '}${word}`
      } else {
        tempArr.push(str)
        str = word
      }
      if (i === words.length - 1) tempArr.push(str)
    }

    const numOfFrames = tempArr.length
    const pace = duration / numOfFrames

    setParameters({
      frames: tempArr,
      maxCharacters,
      numOfFrames,
      pace
    })
  }

  function calculateMaxCharacters() {
    const characters = [...transcript]

    let string = ''
    for (let i = 0; i < characters.length; i++) {
      string += characters[i]
      const fits = checkFit(string, i)
      if (!fits) {
        string = string.substr(0, string.length - 1)
        break
      }
    }

    return string.length
  }

  return (
    <Root ref={rootRef} style={{ height }}>
      {!isPaused && parameters?.frames.length > 0 && playing && (
        <TranscriptionText
          fontSize={textFontSize}
          fontWeight={400}
          lineHeight='130%'
          color={theme?.transcription.text}
          alignment='center'
        >
          {transcriptFrame}
        </TranscriptionText>
      )}
      {isPaused && (
        <Text
          fontSize={textFontSize}
          color={theme?.pausedState.text}
          lineHeight='130%'
          fontWeight={400}
          alignment='center'
        >
          Paused
        </Text>
      )}
    </Root>
  )
}

const Root = styled.div`
  width: 80%;
  margin-top: 0;
`

const TranscriptionText = styled(Text)``
